import * as React from "react";
import ColorPickerText from './ColorPickerText';
import PrayerCalendar from '../prayerSetting/PrayerCalendar';
import { useTimeTableColor } from '../../state/storeTimeTableColor';
import ColorPickerBG from './ColorPickerBG';
import { useLocationStore } from "../../state/storeLocation";

const CustomizingTimeTable = () => {
    const ShowTextColor = useTimeTableColor((state) => state.ShowTextColor);
    const month = useLocationStore((state) => state.month);

    return (
        <div className="flex">
            {ShowTextColor ? <ColorPickerText /> : <ColorPickerBG />}
            {month.method === "13" ? (
                <div className="flex justify-center items-center h-screen w-full">
                    <div className="bg-white p-8 rounded-lg shadow-lg max-w-2xl text-center">
                        <p className="text-gray-700 text-lg leading-relaxed">
                            When designing a timetable, it's best not to choose the month of Ramadan for styling. This is because every time you change a color, the system has to do some extra work to update everything. It uses a complex algorithm, which can slow things down. If you select a different month, the performance will be much smoother. You’ll notice that moving the color picker will be quicker and easier. So, for better speed and ease, pick another month instead of Ramadan.
                        </p>
                    </div>
                </div>
            ) : (
                <PrayerCalendar show={false} />
            )}
        </div>
    );
};

export default CustomizingTimeTable;